export enum AnalyticsContextType {
  GLOBAL = "global",
  GAME = "game",
  PLAYING = "playing",
}

export type GlobalContextI = {
  type: AnalyticsContextType.GLOBAL;
  app_version: string;
  user_pseudo_id: string;
};

export type GameContextI = {
  type: AnalyticsContextType.GAME;
  room_id: string;
  game_id: string;
};

export type PlayingContextI = {
  type: AnalyticsContextType.PLAYING;
  is_host: boolean;
  is_participant: boolean;
  player_name: string;
  player_avatar: string;
  questions_count: number;
  bots_count: number;
  players_count: number;
  total_rounds_count: number;
  current_round: number;
  current_question_index?: number;
  correct_answers_count: number;
  questions_per_round: number;
  question_time_limit: number;
};

export type AnalyticsContextI = GlobalContextI | GameContextI | PlayingContextI;
